import { render, staticRenderFns } from "./SsoLoginPage.vue?vue&type=template&id=917ad804&scoped=true&"
import script from "./SsoLoginPage.vue?vue&type=script&lang=js&"
export * from "./SsoLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./SsoLoginPage.vue?vue&type=style&index=0&id=917ad804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917ad804",
  null
  
)

export default component.exports